module.exports = __webpack_public_path__ + "img/美容水(绿)_02.3cd5227d.jpg";